
import React from "react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { ContractType } from "@/lib/types";
import { DirectionText, getDirectionIcon } from "@/components/contract-types/ContractDirectionIcons";

interface TypeTooltipProps {
  type: ContractType;
  children?: React.ReactNode;
}

export function TypeTooltip({ type, children }: TypeTooltipProps) {
  if (!type) return null;
  
  return (
    <TooltipProvider>
      <Tooltip delayDuration={300}>
        <TooltipTrigger asChild>
          {children ? (
            children
          ) : (
            <span className="cursor-help">{type.name}</span>
          )}
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-xs space-y-2">
          <div className="space-y-1">
            <div className="font-medium">{type.name}</div>
            <div className="text-sm">{type.description || "No description available"}</div>
          </div>
          
          {type.direction && (
            <div className="pt-1 border-t border-gray-200 dark:border-gray-700 text-sm flex items-center gap-1.5">
              {getDirectionIcon(type.direction, "h-3.5 w-3.5")}
              <span><DirectionText direction={type.direction} /></span>
            </div>
          )}
          
          {type.auto_renews && (
            <div className="pt-1 border-t border-gray-200 dark:border-gray-700 text-xs">
              Auto-renews every {type.renewal_interval} {type.renewal_unit?.toLowerCase()}
              {(type.renewal_interval || 0) > 1 ? 's' : ''}
            </div>
          )}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
